import React from 'react'
import { useStore } from 'react-redux'
import { Table } from 'rsuite'
import CheckboxComponent from '../CommonComponents/CheckboxComponent'
import ThreeStateCheckbox from '../CommonComponents/ThreeStateCheckbox'
import { validationFields, validationCols } from '../../utils/constants/reportFilters'

import {
  validateFieldValue,
  formatValue,
  validateLinkedField
} from '../../utils/validator/index'
import { checkIsAdmin } from '../../services/helper'

const { Column, HeaderCell, Cell } = Table

const WarningCell = ({ rowData, dataKey, columns, onChange, editingIds, isAdmin, ...props }) => {
  const store = useStore().getState()
  const { app: {
    currentDataSource
  }
  } = store
  let requiredFields = ['address1', 'city', 'state', 'zip']
  let validate;
  const field = columns.filter(col => col.name === dataKey)[0]
  if (currentDataSource?.value === 'bulkUpdate' && validationCols?.includes(field.name)) {
    let value = rowData[dataKey]
    validate = validateLinkedField(rowData, field, validationFields);
  } else if (field.name === 'phone' || field.name === 'cardPaymentByPhoneValue') {
    let value = rowData[dataKey]
    let isExt = rowData[dataKey] && rowData[dataKey].toString().match(/x|ext|ext./)
    if (isExt && isExt.length > 0) {
      let parsePhone = rowData[dataKey].split(isExt[0])
      value = parsePhone[0].trim()
    }
    validate = validateFieldValue(field, value)
  } else {
    if (requiredFields.includes(dataKey) && !rowData[dataKey]) {
      validate = false
    } else {
      validate = validateFieldValue(field, rowData[dataKey], isAdmin)
    }
  }
  const formatedValue = formatValue(rowData[dataKey], field?.dataType)
  const idEditing = editingIds && editingIds.includes(rowData.id) && field?.editable ? true : false

  return (
    <Cell {...props} className="table-content-editing">
      {
        field?.dataType === 'boolean' ? (
          field?.type === 'threestate' ?
            <div className={`table-content-edit-span ${validate ? '' : 'error'}`}>
              <ThreeStateCheckbox
                checked={formatedValue}
                onChange={(isChecked) => onChange(rowData.id, dataKey, field?.dataType, isChecked)}
              />
            </div>
            :
            <div className={`table-content-edit-span ${validate ? '' : 'error'}`}>
              <CheckboxComponent
                checked={formatedValue}
                onChange={(isChecked) => onChange(rowData.id, dataKey, field?.dataType, isChecked)}
              />
            </div>
        ) : (
          (!validate || idEditing) ? (
            <input
              key={rowData.id}
              type="text"
              className={`table-content-edit-span ${validate ? '' : 'error'}`}
              defaultValue={formatedValue}
              onChange={(e) => onChange && onChange(rowData.id, dataKey, field?.dataType, e.target.value)}
              placeholder={field?.name === 'taxId' ? '987-65-4321' : field?.name === 'sic' ? '1234' : field?.name === 'naics' ? '12345' : field?.name === 'employerIdNumber' ? '65-6785643' : ''}
            />
          ) : (
            <div
              className={`table-content-edit-span ${validate ? '' : 'error'}`}
            >
              {formatedValue}
            </div>
          )
        )
      }
    </Cell>
  )
}

const PreviewTable = ({ filteredTableData, tableHeader, onChange, columns, editingIds, onEditState }) => {
  const store = useStore().getState()
  const {
    domain: {
      currentDomain,
    }
  } = store
  const isAdmin = checkIsAdmin(currentDomain)

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="table-content-action" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className="btn btn-green"
          onClick={() => {
            onEditState && onEditState(rowData.id);
          }}
        >
          {editingIds && editingIds.includes(rowData.id) ? 'Save' : 'Edit'}
        </button>
      </Cell>
    )
  }
  const headers = tableHeader.map(h => {
    return (
      <Column
        resizable
        sortable
        key={h.matchedName}
      >
        <HeaderCell>
          <span className={`preview-header-column ${h.required ? 'bold' : ''}`}>
            {h.label}
          </span>
        </HeaderCell>
        <WarningCell dataKey={h.matchedName} columns={columns} onChange={onChange} editingIds={editingIds} isAdmin={isAdmin} />
      </Column>
    )
  })

  return (
    <Table
      key={`preview-table-key-${columns?.length}`}
      virtualized
      affixHeader={true}
      data={filteredTableData}
      autoHeight
      affixHorizontalScrollbar={true}
    >
      {headers}
      <Column
        width={100}
        fixed='right'
      >
        <HeaderCell>Action</HeaderCell>
        <ActionCell
          dataKey='id'
        />
      </Column>
    </Table>
  )
}

export default PreviewTable